import Navbar from '@/components/Landing/Nav/Nav.vue'
import Map from '@/components/Map/Map.vue'
import AdMenu from '@/components/Main/AdMenu/AdMenu.vue'
import CallHeader from '@/components/Main/Call/CallHeader.vue'
import CallCard from '@/components/Main/Call/CallCard.vue'

import LoginModal from "@/components/Auth/LoginModal/LoginModal.vue";
import InviteModal from "@/components/Auth/InviteModal/InviteModal.vue";
import ResetModal from "@/components/Auth/ResetModal/ResetModal.vue";
import SignupModal from "@/components/Auth/SignupModal/SignupModal.vue";

import AddToCall from '@/components/Main/AddToCall/AddToCall.vue'
import CircleService from '@/services/circle'
import ProfileService from '@/services/profile'

const circleService = new CircleService();
const profileService = new ProfileService();
const LIMIT = 4;

export default {
  name: 'Call',
  props: ['auth', 'authenticated'],
  components: {
    Navbar,
    Map,
    AdMenu,
    CallHeader,
    CallCard,
    LoginModal,
    InviteModal,
    ResetModal,
    SignupModal,
    AddToCall,
  },
  data() {
    return {
      authFlag: this.$props.authenticated,
      tracker: null,
      trackers: null,
      altHeaderText: null,
      page: 1,
      coordinates: { lat: 9.0748812, lng: 7.465183 },
      markers: null,
      infoWindows: null,
      suggestedProfile: {phone: ''},
      selectedTracker: null,
    }
  },
  created() {
    circleService.getCall(LIMIT, this.page).then(data => {
      this.markers = data.locations.map(location => {
        return {
          position: {lat: location.latitude, lng: location.longitude},
          shape: {path: 'ellipse', fillColor: 'yellow', fillOpacity: 0.4}
        }
      })
      if (data) {
        this.tracker = data._id;
        const trackers = data.children;
        if (trackers.length === LIMIT) {
          this.page += 1
        }
        this.trackers = [...(this.trackers || []), ...trackers]

      } else {
        this.altHeaderText = 'Calls not available at this time';
        this.trackers = [];
      }
    }).catch(err => {
      (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
    })

    profileService.getSuggestedProfile()
      .then(res => {
        this.suggestedProfile = {...res, phone: ''};
      }).catch(err => {
        console.log('suggested profile error: ', err);
      })

  },
  mounted () {
    this.geolocate()
  },
  methods: {
    loadMore(e) {
      const btn = e.srcElement;

      btn.disabled = true;
      btn.innerText = 'Loading'
      btn.classList.add('btn--loading');

      circleService.getCall(LIMIT, this.page).then(data => {
        this.tracker = data._id;
        const trackers = data.children;

        if (data) {
          this.page += 1
        }

        const allTrackers = [...(this.trackers || []), ...trackers];

        this.trackers = Array.from(new Set(allTrackers.map(s => s._id))).map(s => allTrackers.find(a => a._id === s));

        btn.disabled = false;
        btn.innerText = 'Load more'
        btn.classList.remove('btn--loading');
      }).catch(err => {
        btn.disabled = false;
        btn.innerText = 'Load more'
        btn.classList.remove('btn--loading');

        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
          (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
      })
    },
    has(obj, path) {
      if (typeof path !== "string") {
        return false;
      }
      var path_array = path.split(".");
      if (obj.hasOwnProperty(path_array[0])) {
        if (path_array.length > 1) {
          var newPath = path_array
            .slice(1)
            .join(".")
            .toString();
          return has(obj[path_array[0]], newPath);
        }
        return obj.hasOwnProperty(path_array[0]);
      }
      return false;
    },
    setSelectedTracker(tracker) {
      this.selectedTracker = tracker
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.coordinates = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
}
